import {usePost} from '../useHttpHooks.ts';
import {ServerSignInResponse} from '../types.ts';
import {SocialMediaToken} from '../../types.ts';

const useAuthMicrosoft = () =>
    usePost<SocialMediaToken, ServerSignInResponse>('/api/auth/microsoft', {
        errorMessage: 'Failed to authenticate',
        includeCredentials: true
    });

export default useAuthMicrosoft;
